import SetFilterFieldValues from './SetFilterFieldValues';

const SetInitialSortedColumn = (config, state) => {
    let initialSortedColumnDescending = false;
    let initialSortedColumn = config.GridColumns.filter((col) => col.IsSorted === true)[0];
    if (initialSortedColumn !== undefined) {
        initialSortedColumnDescending = initialSortedColumn.IsSortedDescending;
    } else {
        initialSortedColumn = { FieldName: " "}
    }
    return {...state, sortedColumn: initialSortedColumn.FieldName, descending: initialSortedColumnDescending }
}

const UpdateSortedColumn = (fieldName, state) => {
    if (fieldName === state.sortedColumn) {
        state.descending = ! state.descending;
    } else {
        state.sortedColumn = fieldName;
        state.descending = false;
    }
    return {...state};
}

const SetDefaultPreset = (config, state) => {
    let defaultPreset;
    let filters = state.filters;
    if (config.FilterPresets !== "") {
        defaultPreset = config.FilterPresets.filter((f) =>  f.Default === true)[0];
        if (defaultPreset !== undefined) {
            filters = SetFilterFieldValues(defaultPreset,state.filters)
            state.oldFilters = filters;
            state.selectedPreset = defaultPreset;
        } else {
            state.selectedPreset = null;
        }
    }

    return {...state, preset: defaultPreset, filters: filters, textSearch: ""}
}

const SetDefaultFiltersPassedIn = (data, state) => {
    const option = {key: data.id.toString(), selected: true};
    state = ChangeFilterCondition(option, data.type, state)

    // if (data.type !== "state") {
    //     const states = ["525", "526", "527", "528", "529", "530", "531", "532", "533", "535", "537"];
    //     for (const item of states) {
    //         state = ChangeFilterCondition({key: item, selected: true}, "state", state);
    //     }
    // }

    return state;
}

const SelectPreset = (preset, state) => {
    if (state.selectedPreset === null || state.selectedPreset === undefined) {
        state.oldFilters = state.filters;
        state.filters = SetFilterFieldValues(preset,state.filters)
        state.selectedPreset = preset;
    } else {
        if (state.selectedPreset.Key !== preset.Key) {
            state.filters = SetFilterFieldValues(preset,state.filters)
            state.selectedPreset = preset;
        } else {
            state.filters = state.oldFilters;
            state.oldFilters = [];
            state.selectedPreset = null;
        }
    }

    return {...state, textSearch: ""}
};

const ChangeFilterCondition = (option, key, state) => {
    const newFilters = state.filters;
    let changedFilter = newFilters.filter((f) => f.Key === key )[0];

    if (option.selected === undefined) {
        if (Array.isArray(option)) {
            changedFilter.values = option;
        } else {
            changedFilter.values = [option.key];
        }
    } else {
        if (option.selected) {
            changedFilter.values = changedFilter.values === undefined ? [option.key] : [...changedFilter.values,option.key];
        } else {
            changedFilter.values = changedFilter.values.filter(key => key !== option.key);
        }
    }

    state.filters = newFilters;
    state.selectedPreset = null;

    return {...state }
}

export {SetInitialSortedColumn, SetDefaultPreset, UpdateSortedColumn, SelectPreset, ChangeFilterCondition, SetDefaultFiltersPassedIn};